import React from "react";

import Keycloak from 'keycloak-js';
import LoadingAuth from "./components/LoadingAuth";
import store from "./redux/store/index";
import TanseeqWebRoutes from "./routes/TanseeqWebRoutes";
import ReduxToastr from "react-redux-toastr";

import { Provider } from "react-redux";
import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import { useSessionStore } from './services/stores';
import { useEffect } from 'react';
import { setupInterceptors } from './services/apiService';

export const kc = new Keycloak({
    url: 'https://login.phyto.ma',
    realm: "phytostrategies",
    clientId: "ps-inventory",
})

const initOptions = {
  onLoad: 'check-sso' , // 'check-sso' | check-sso | login-required
  pkceMethod: 'S256'
}

const UserLogin = () => {

  const {keycloak, initialized: keycloakInitialized} = useKeycloak();
  const {getIdentity, setCurrentUser} = useSessionStore();

  useEffect(() => {
    if (keycloak.authenticated) {
      getIdentity(keycloak)
        .then((user: any) => {setCurrentUser(user)})
        .catch((error) => {
          console.log('Failed to get user identity:', error);
        }); 
    }
      
  setupInterceptors(keycloak);

  }, [keycloak, keycloakInitialized]);
  
  return (
    <></>
  )
}
/**
 * Top-level TSX Component
 * 
 */
const App = () =>  {

  return (
    <ReactKeycloakProvider
      authClient={kc}
      initOptions={initOptions}
      LoadingComponent={<LoadingAuth />}
    >
      <Provider store={store}>
        <TanseeqWebRoutes />
        <ReduxToastr
          timeOut={5000}
          newestOnTop={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick
        />
        <UserLogin />
      </Provider>
  </ReactKeycloakProvider>    
)};

export default App;
